import * as actions from './actions'
import * as getters from './getters'
import * as types from '../mutation-types'

const state = {
  userData: {
    id: '',
    email: '',
    displayName: '',
    avatar: '',
    isActived: false,
    status: 'pending'
  },
  token: '',
  company: {},
  companies: {},
  companyVacancies: {},
  recruitedResumes: {},
  recruitedResume: {}
}

const mutations = {
  [types.MANIPULATOR_TOKEN] (state, data) {
    state.token = data
  },
  [types.MANIPULATOR_DATA] (state, data) {
    state.userData = data
  },
  [types.MANIPULATOR_COMPANY] (state, data) {
    state.company = data
  },
  [types.MANIPULATOR_COMPANIES] (state, data) {
    state.companies = data
  },
  [types.MANIPULATOR_COMPANY_VACANCIES] (state, data) {
    state.companyVacancies = data
  },
  [types.COMPANY_RECRUITED_RESUMES] (state, data) {
    state.recruitedResumes = data
  },
  [types.COMPANY_RECRUITED_RESUME] (state, data) {
    state.recruitedResume = data
  }
}

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}



// WEBPACK FOOTER //
// ./src/vuex/manipulators/store.js